import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import { 
  Character, 
  CharacterFeatureSource, 
} from "@dndModels";

import CenteredMenu from "@components/input/menus/CenteredMenu";
import CharacterKnowledgeMainInput from "@dndComponents/character/knowledge/CharacterKnowledgeMainInput";
import CharacterManageSpells from "@dndComponents/character/spells_and_abilities/CharacterManageSpells";
// import CharacterManageRecipes from './CharacterManageRecipes';

interface Props {
  char: Character; 
}

export default function CharacterSpellsAndKnowledge({
  char,
}: Props) {
  const [view, setView] = useState<"Spells"|"Recipes"|"Other">("Spells");

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <CenteredMenu
          // options={char.character_options.use_item_crafting ? ["Spells","Recipes","Other"] : ["Spells","Other"]}
          options={["Spells","Other"]}
          selected={view}
          onSelect={(changed: string) => {
            setView(changed as "Spells"|"Recipes"|"Other");
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        { view === "Spells" ? 
          <CharacterManageSpells
            character={char}
          />
        // : view === "Recipes" ? 
        //   <CharacterManageRecipes
        //     char={char}
        //     onChange={onChange}
        //   />
        :
          <CharacterKnowledgeMainInput
            character={char}
          />
        }
      </Grid>
    </Grid>
  );
}
